import { DcBaseComponent } from '@deleteagency/dc';
import scrollIntoView from 'scroll-into-view';

export default class AccordionOpener extends DcBaseComponent {
    static getNamespace() {
        return 'accordion-opener';
    }

    static getRequiredRefs() {
        return ['accordions', 'triggers', 'contents'];
    }

    onInit() {
        this._scrollToAccordion();
    }

    _scrollToAccordion() {
        if (!location.hash) return;

        const indexAccordion = this._getIndexAccordionByHash();
        const accordion = this.refs.accordions[indexAccordion];

        this._closeAccordions();
        this._openOrCloseAccordion(indexAccordion, true);

        document.body.classList.add('scrolling');

        scrollIntoView(accordion, {
            time: 1000,
            align: {
                top: 0,
                topOffset: 5,
            }
        }, () => {
            document.body.classList.remove('scrolling');
        });
    }

    _getIndexAccordionByHash() {
        const { accordions } = this.refs;

        for (let index = 0; index < accordions.length; index++) {
            const id = accordions[index].getAttribute('id').replace(/-id-[\d]+$/i, '');

            if (`#${id}` === location.hash) return index;
        }
    };

    _closeAccordions() {
        this.refs.accordions.forEach((accordion, index) => {
            if (!accordion.classList.contains('open')) return;

            this._openOrCloseAccordion(index);
        });
    }

    _openOrCloseAccordion(index = 0, isExpanded = false) {
        const { accordions, triggers, contents } = this.refs;

        accordions[index].classList[isExpanded ? 'add' : 'remove']('open');

        triggers[index].classList[isExpanded ? 'remove' : 'add']('collapsed');
        triggers[index].setAttribute('aria-expanded', `${isExpanded ? 'true' : 'false'}`);

        contents[index].classList[isExpanded ? 'add' : 'remove']('show');
        contents[index].classList[isExpanded ? 'remove' : 'add']('collapse');
    }
}
